import { createStart, createCsrfMiddleware, createMiddleware } from "@tanstack/react-start";
import { getRequest, getRequestHeader } from "@tanstack/react-start/server";

import { renderErrorPage } from "./lib/error-page";
import { attachSupabaseAuth } from "@/integrations/supabase/auth-attacher";

const PRIMARY_HOST = "sunsetconcept.store";
const ALT_HOSTS = ["www.sunsetconcept.store", "sunset.store", "www.sunset.store"];

const redirectMiddleware = createMiddleware().server(async ({ next }) => {
  const request = getRequest();
  const url = new URL(request.url);
  const host = url.host.toLowerCase();
  const proto = (getRequestHeader("x-forwarded-proto") ?? url.protocol.replace(":", "")).toLowerCase();

  const isLocal = host === "localhost" || host.startsWith("localhost:") || host.includes(".local");
  const isPreview = host.startsWith("id-preview--") || host.includes("-dev.lovable.app");
  if (isLocal || isPreview) {
    return next();
  }




  const shouldRedirectToHost = ALT_HOSTS.includes(host);
  const shouldRedirectToHttps = proto !== "https" && (host === PRIMARY_HOST || ALT_HOSTS.includes(host));


  if (shouldRedirectToHost || shouldRedirectToHttps) {
    const target = new URL(url.pathname + url.search, `https://${PRIMARY_HOST}`);
    return new Response(null, {
      status: 301,
      headers: {
        Location: target.toString(),
        "Strict-Transport-Security": "max-age=31536000; includeSubDomains",
      },
    });
  }

  return next();
});


const errorMiddleware = createMiddleware().server(async ({ next }) => {
  try {
    return await next();
  } catch (error) {
    if (error != null && typeof error === "object" && "statusCode" in error) {
      throw error;
    }
    console.error(error);
    return new Response(renderErrorPage(), {
      status: 500,
      headers: { "content-type": "text/html; charset=utf-8" },
    });
  }
});

// Start installs this automatically when src/start.ts is absent; defining the
// file opts out, so re-add it explicitly to keep server functions protected
// from cross-site requests.
const csrfMiddleware = createCsrfMiddleware({
  filter: (ctx) => ctx.handlerType === "serverFn",
});

export const startInstance = createStart(() => ({
  functionMiddleware: [attachSupabaseAuth],
  requestMiddleware: [redirectMiddleware, errorMiddleware, csrfMiddleware],
}));
